//用户列表
export const GET_USERINFOR_LOAD='header/userInfo/GET_USERINFOR_LOAD';
export const GET_USERINFOR_LIST='header/userInfo/GET_USERINFOR_LIST';
export const SET_USERINFOR_LIST='header/userInfo/SET_USERINFOR_LIST';
export const RESET_DATA='RESET_DATA'; //退出登录清空store数据
